<div class="modal-content">
  <div class="modal-header">
    <h4>Vizsgázó adat eltérések</h4>
  </div>
  <div class="modal-body">
    <div *ngIf="!isLoading">
      <table class="table table-striped">
        <thead>
        <tr>
          <th>Eltérő adat</th>
          <th>Régi érték</th>
          <th>Új érték</th>
        </tr>
        </thead>
        <tbody>
          <tr *ngFor="let change of changes">
            <td>{{change.property}}</td>
            <td>{{change.change?.oldValue}}</td>
            <td>{{change.change?.newValue}}</td>
          </tr>
        </tbody>
      </table>
      <div class="mt-5 mb-5" *ngIf="isLoading">
        <app-loader></app-loader>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-dark" (click)="close()">Bezárás</button>
    </div>
  </div>
</div>
